export interface FileStepData {
  previousStep?: number;
  step: number;
  file?: File;
  error?: boolean;
}
